<template>
    <Paper class="other-tenant">
        <div class="other-tenant-date">
            <el-date-picker
                ref="datePicker"
                type="date"
                @change="changeDate"
                value-format="yyyy-MM-dd"
                v-model="time"
                :clearable="false">
            </el-date-picker>
            <i @click="clickDate" class="tenant-date-icon el-input__icon el-icon-date"></i>
        </div>
        <div class="other-tenant-content">
            <div class="other-tenant-content-top other-tenant-content-item">
                <div class="other-tenant-content-left other-tenant-content-left-top">
                    <div class="interface-call-situation">
                        <!-- 接口调用情况 -->
                        <callSituation ref="callSituation"></callSituation>
                    </div>
                </div>
                <div class="new-other-tenant-content-right">
                    <div class="bar-code-acquisition">
                        <!-- 条码采集量统计 -->
                        <barCodeAcquisition ref="barCodeAcquisition"></barCodeAcquisition>
                    </div>
                    <!-- 消息 -->
                    <message ref="message"></message>
                </div>
            </div>
            <div class="other-tenant-content-center other-tenant-content-item">
                <!-- 接口调用统计 -->
                <interfaceCall
                ref="interfaceCall">
                </interfaceCall>
            </div>
            <div class="other-tenant-content-item">
                <!-- 接口调用异常预警 -->
                <abnormalWarn ref="abnormalWarn"></abnormalWarn>
            </div>
            <div class="other-tenant-content-bottom other-tenant-content-item">
                <div class="other-tenant-content-left">
                    <!-- 页面操作延时TOP、页面操作频次TOP5 -->
                    <timeDelay
                    ref="tenantTimeDelay">
                    </timeDelay>
                </div>
                <div class="other-tenant-content-right">
                    <!-- 中间表数据处理情况 -->
                    <middleTable
                    ref="middleTable">
                    </middleTable>
                </div>
            </div>
        </div>
    </Paper>
</template>
<script>
import dayjs from 'dayjs';
import Paper from '@/components/core/paper/Paper';
import callSituation from './components/callSituation';
import barCodeAcquisition from './components/barCodeAcquisition';
import interfaceCall from './components/interfaceCall/index.vue';
import abnormalWarn from './components/abnormalWarn';
import middleTable from './components/middleTable';
import message from './components/message';
import timeDelay from './components/timeDelay';
import random from '../../../../utils/random';
import { searchNotic } from '../../../../api/systemManagementApi';
import { TENANT_CODE_LIST } from './otherTenantConst';
import { getAcquisitionApi, getTimeDelayApi, getMiddleTableApi, getAbnormalWarnApi, getCallSituationApi, getTimeDelayTopApi, createTime } from '../../../../api/afterLoginIndex';
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            time: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
            getDataTime: null,
            refreshTime: 120 * 60 * 1000
        };
    },
    computed: {
        ...mapGetters(['currentTenant'])
    },
    components: {
        Paper, callSituation, barCodeAcquisition, interfaceCall, abnormalWarn, timeDelay, middleTable, message
    },
    methods: {
        onreSize() {
            const that = this;
            window.addEventListener('resize', that.task);
        },
        removeSize() {
            const that = this;
            window.removeEventListener('resize', that.task);
        },
        task: random.debounce(function() {
            this.againDrawEcharts();
        }, 1000),
        againDrawEcharts() {
            this.getInterfaceCallBar();
            this.drawTimeDelay();
        },
        changeDate() {
            this.loadData();
        },
        loadData() {
            const { tenantCode } = this.currentTenant;
            const params = {
                time: this.time,
                tenantCode: tenantCode
            };
            // 接口调用情况、接口调用统计
            this.getCallSituation(params);
            // 条码采集量统计
            this.getAcquisition(params);
            // 接口调用异常预警
            this.getAbnormalWarn(params);
            // 页面延时操作
            this.getTimeDelay();
            //  中间表数据处理情况
            this.getMiddleTable();
            // 消息
            this.getMessage();
        },
        getCallSituation(params) {
            const { tenantCode, time } = params;
            const disposeTime = createTime(time);
            getCallSituationApi({ tenantCode, ...disposeTime }).then(res => {
                if (res && +res.code === 0) {
                    const callSituation = this.$refs.callSituation;
                    callSituation && callSituation.dataProcess(res.data || {});
                    const interfaceCall = this.$refs.interfaceCall;
                    interfaceCall && interfaceCall.dataProcess(res.data || {});
                }
            });
        },
        getMessage() {
            const { tenantCode } = this.currentTenant;
            const params = {
                subject: '',
                contentType: TENANT_CODE_LIST[tenantCode],
                pageNo: 1,
                pageSize: 10,
                orderBy: 'updateTime',
                orderByType: 'desc',
                state: 0
            };
            searchNotic(params).then(res => {
                if (res && +res.code === 0) {
                    const message = this.$refs.message;
                    message && message.dataProcess(res.data.list);
                }
            });
        },
        getAcquisition(params) {
            const { tenantCode, time } = params;
            const disposeTime = createTime(time);
            getAcquisitionApi({ tenantCode, ...disposeTime }).then(res => {
                if (res && +res.code === 0) {
                    const barCodeAcquisition = this.$refs.barCodeAcquisition;
                    barCodeAcquisition && barCodeAcquisition.dataProcess({ ...res.data, time: this.time });
                }
            });
        },
        getInterfaceCallBar() {
            const interfaceCall = this.$refs.interfaceCall;
            this.$nextTick(() => {
                if (interfaceCall) {
                    interfaceCall.drawSearchEcharts();
                    interfaceCall.drawGatherEcharts();
                }
            });
        },
        getAbnormalWarn(params) {
            getAbnormalWarnApi(params).then(res => {
                if (res && +res.code === 0) {
                    const abnormalWarn = this.$refs.abnormalWarn;
                    abnormalWarn && abnormalWarn.dataProcess({ data: res.data, time: this.time, tenantCode: params.tenantCode });
                }
            });
        },
        drawTimeDelay() {
            const tenantTimeDelay = this.$refs.tenantTimeDelay;
            this.$nextTick(() => {
                if (tenantTimeDelay) {
                    tenantTimeDelay.drawEcharts();
                }
            });
        },
        getTimeDelay() {
            const params = {
                startTime: this.time + ' 00:00:00',
                endTime: this.time + ' 23:59:59'
            };
            // 页面操作频次TOP5
            getTimeDelayApi(params).then(res => {
                if (res && +res.code === 0) {
                    const tenantTimeDelay = this.$refs.tenantTimeDelay;
                    tenantTimeDelay && tenantTimeDelay.dataProcess(res.data);
                }
            });
            const { tenantCode } = this.currentTenant;
            params.tenantCode = tenantCode;
            // 页面操作延时TOP
            getTimeDelayTopApi(params).then(res => {
                if (res && +res.code === 0) {
                    const tenantTimeDelay = this.$refs.tenantTimeDelay;
                    tenantTimeDelay && tenantTimeDelay.dataEchartsProcess({ data: res.data, time: this.time });
                }
            });
        },
        getMiddleTable() {
            const { tenantCode } = this.currentTenant;
            const params = {
                time: this.time,
                tenantCode
            };
            getMiddleTableApi(params).then(res => {
                if (res && +res.code === 0) {
                    const middleTable = this.$refs.middleTable;
                    middleTable && middleTable.dataProcess(res.data);
                }
            });
        },
        clickDate() {
            this.$refs.datePicker.focus();
        }
    },
    mounted() {
        this.onreSize();
        random.refreshData(this, 'loadData', this.refreshTime, 'getDataTime');
    },
    beforeDestroy() {
        this.removeSize();
        window.clearTimeout(this.getDataTime);
    }
};
</script>
<style lang="less">
.other-tenant{
    height: calc(100vh - 50px);
    overflow: auto;
    background: #f5f5f5 !important;
    padding: 0;
}
.other-tenant-date{
    width: 222px;
    margin-bottom: 10px;
    position: relative;
    .el-input__prefix{
        display: none;
    }
    .el-input__inner{
        padding-left: 14px;
    }
    .tenant-date-icon{
        position: absolute;
        right: 16px;
        font-size: 14px;
        color: #666666;
        cursor: pointer;
    }
}
.other-tenant-content{
    .other-tenant-title{
        margin-bottom: 16px;
        display: block;
        font-family: 'PingFangSC-Regular', sans-serif;
        line-height: 18px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
    }
    .other-tenant-item-content{
        padding: 20px;
        background: #ffffff;
        border-radius: 4px;
    }
}
.other-tenant-content-item{
    width: 100%;
    margin-bottom: 10px;
}
.other-tenant-content-top,.other-tenant-content-bottom{
    display: flex;
    justify-content: space-between;
}
.other-tenant-content-left{
    width: 60%;
}
.new-other-tenant-content-right{
    // width: 380px;
    flex: 1;
    margin-left: 10px;
    display: flex;
    // flex-direction: column;
    .bar-code-acquisition {
        flex: 1;
    }
    .other-tenant-message {
        width: 300px;
        margin-left: 10px;
    }
}
.other-tenant-content-right{
    width: 380px;
}
// .other-tenant-content-item{
//     margin-bottom: 10px;
// }
.other-tenant-content-left-top{
    display: flex;
    justify-content: space-between;
    .interface-call-situation{
        width: 100%;
    }
    .bar-code-acquisition{
        // width: calc(27% - 10px);
    }
}
</style>
